// CustomAutocomplete.js
import { useMediaQuery } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import React from "react";

const CustomAutocomplete = ({ options, value, onChange, label,getOptionLabel }) => {
  const isMediumScreen = useMediaQuery('(min-width: 960px)');
  return (
    <span style={{ minWidth: isMediumScreen ? "100%" : "150px" }}>
    <Autocomplete
      disablePortal
      options={options||[]}
       getOptionLabel={getOptionLabel}
      value={value}
      onChange={onChange}
      // isOptionEqualToValue={(option, value) =>
      //    option.label === value?.label && option.value === value.value
      // }
      renderInput={(params) => <TextField {...params} label={label} />}
    />
    </span>
  );
};

export { CustomAutocomplete };

